export default {
  // These styles were ported over from previous vendors work and need to be validated
  lineHorizontal: {
    borderTopWidth: 1.5,
  },
  alternativeLabel: {
    top: 18,
  },
};
